export default "__VITE_ASSET__COnnbCsH__";